import imgOutside from '../../assetsFr/buildings/hotel/outside.jpg';
import imgFireProtection from '../../assetsFr/buildings/hotel/fire-protection.jpg';
import imgWater from '../../assetsFr/buildings/hotel/water.jpg';
import { Building } from '../../interfaces/buildings';
import { TechSector } from '../tech-sector';
import { ProductType } from '../products';
import { isNoBoolean } from '../../components/utils/isNoBoolean';

const hotelConfig: Building = {
    techSectors: [
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                    position: { x: 776, y: 900 },
                    type: ProductType.HYADUO_2_D_FL_COMPACT,
                },
                {
                    position: { x: 990, y: 906 },
                    type: ProductType.ETANORM_FXV,
                },
            ],
        },
        {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                    position: { x: 390, y: 650 },
                    type: ProductType.MOVITEC,
                },
                {
                    position: { x: 457, y: 835 },
                    type: ProductType.SISTO_16_TWA,
                },
                {
                    position: { x: 660, y: 820 },
                    type: ProductType.DELTA_PRIMO_SVP,
                },
                {
                    position: { x: 680, y: 670 },
                    type: ProductType.BOAX_S_SF,
                },
                {
                    position: { x: 803, y: 827 },
                    type: ProductType.BOA_COMPACT_EKB,
                },
                {
                    position: { x: 1750, y: 885 },
                    type: ProductType.UPA,
                },
            ],
        },
    ].filter(isNoBoolean),
    img: imgOutside,
};

export default hotelConfig;
